<script lang="ts">
	import Modal from './Modal.svelte';
	import AbleyButton from './AbleyButton.svelte';

	import { appStore } from '#lib/stores/appStore.svelte.js';
	import { enquiryMailto } from '#lib/apps/contact.js';

	interface Props {
		open: boolean;
		apiKey: string;
		clear: () => void;
		onclose: () => void;
	}

	const { open, apiKey, clear, onclose }: Props = $props();

	const mailto = $derived(enquiryMailto(appStore.app));

	const showStartCount = 4;
	const showEndCount = 4;

	const redactedApiKey = $derived.by(() => {
		const keyLen = apiKey.length;
		if (!apiKey || keyLen === 0) return '';
		if (keyLen > (showStartCount + showEndCount) * 2) {
			return (
				apiKey.slice(0, showStartCount) +
				'*'.repeat(keyLen - showStartCount - showEndCount) +
				apiKey.slice(keyLen - showEndCount)
			);
		}
		return '*'.repeat(keyLen);
	});

	function resetKey() {
		clear();
		onclose();
	}
</script>

<Modal {open} title="Current access key" {onclose}>
	{#snippet footer()}
		<AbleyButton variant="text" onclick={resetKey}>Use a different key</AbleyButton>
		<AbleyButton variant="outlined" href={mailto}>Access more data</AbleyButton>
	{/snippet}

	<label class="field">
		<span>This is the access key you have been provided.</span>
		<input type="text" value={redactedApiKey} readonly />
	</label>
</Modal>

<style>
	.field {
		display: flex;
		flex-direction: column;
		gap: var(--space-3);

		input {
			font-family: var(--font-mono);
			text-align: center;
		}
	}
</style>
